package de.oevbs.kunde.kundenportal2.services.claims

import de.oevbs.businesspartner.bpcrmservice2.claim.model.Claim
import de.oevbs.kunde.kundenportal2.authentication.PortalSessionMiddleware
import de.oevbs.kunde.kundenportal2.components.globalInitTracker
import de.oevbs.kunde.kundenportal2.util.tryCatchAndHandleErrors
import de.oevbs.sfa.communication.use
import dev.fritz2.core.RootStore
import dev.fritz2.core.SimpleHandler
import dev.fritz2.core.storeOf
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.Flow

/**
 * Die Stores für Inbox, Vertragsdetails und Schäden sind die einzigen der "Selfservices" Stores, die als object angelegt
 * werden sollten. da keine Schritte/Ändern von Daten passiert und damit die Daten vorhanden bleiben können.
 * Alle anderen Stores bitte als Klassen anlegen und in der Haupt-Renderfunktion des jeweiligen Self-Services
 * instantiieren. Dies hat den großen Vorteil, dass alle Submit-Daten, Schritte usw. mit der Variablen gelöscht werden
 * und ein Self-Service immer mit frischen Daten aus dem Backend initialisiert ist.
 */
object ClaimsStore : RootStore<List<Claim>>(emptyList(), Job()) {

    private val client = ClaimsClient().use(PortalSessionMiddleware)

    private val initFailedStore = storeOf(false, job)
    val initFailedFlow: Flow<Boolean> = initFailedStore.data

    val loadClaims: SimpleHandler<Unit> = handle {
        globalInitTracker.track {
            val initData = tryCatchAndHandleErrors("Initialisieren der Schaden-Liste") {
                client.init()
            }?.claims

            if (initData == null) {
                initFailedStore.update(true)
                return@track emptyList()
            }
            initData
        }
    }
}